// @vendors
const { connect } = require('react-redux');
// @components
const ChatMessages = require('./ChatMessages');
// @actions
const chatActions = require('actions/chat');

const mapStateToProps = (state) => ({
    conversationStatus: state.okChat.get('conversationStatus'),
    messages: state.okChat.get('messages'),
    userAvatar: state.profile.get('avatar'),
    userFirstName: state.profile.get('nombreCliente').trim()
});
const mapDispatchToProps = ({
    addWelcomeMessage: chatActions.addWelcomeMessage,
});

const ChatMessagesContainer = connect(mapStateToProps, mapDispatchToProps)(ChatMessages);

module.exports = ChatMessagesContainer;
